import React, { useState } from 'react';
import { T } from '@tolgee/react';
import { SypacButton, SypacText } from '@sypac/component-library-react';
import HideMap from '../../../../../assets/HideMap';
import { MapIcon } from '../../../../../assets/MapIcon';
import WarningIcon from '../../../../../assets/WarningIcon';
import OrderRouteMap from '../../../../../components/OrderRouteMap/OrderRouteMap';
import { OrderInterface } from '../../../../../components/OrdersTable/interfaces/Order.interface';
import { TrackingRouteMode } from '../../../../Public/OrderTracking/orderTracking.interface';

interface TruckDetailsMapProps {
	selectedOrder: OrderInterface | undefined;
	mode?: TrackingRouteMode;
	showPendingTrucks?: boolean;
}

const TruckDetailsMap: React.FC<TruckDetailsMapProps> = ({
	selectedOrder,
	mode = 'full',
	showPendingTrucks = false,
}) => {
	const [isMapOpen, setIsMapOpen] = useState<boolean>(true);

	const toggleMap = () => {
		setIsMapOpen(!isMapOpen);
	};

	return (
		<div className="bg-white border border-solid border-gray-10 rounded-xl">
			{isMapOpen && (
				<div className="flex justify-between px-5 pt-4 mb-4">
					<SypacText variant="body-normal-medium">
						<p className="text-gray-60">
							<T keyName="detailsMap.routeDetails">Route details</T>
						</p>
					</SypacText>

					<div className="flex items-center gap-3 cursor-pointer ml-auto">
						<span className="flex scale-[1.1]">
							<HideMap />
						</span>
						<SypacButton variant="secondary" size="small">
							<button
								className="w-full border-none bg-transparent p-0 group"
								type="button"
								onClick={toggleMap}
							>
								<SypacText variant="body-normal-medium">
									<p className="transition group-hover:text-gray-80">
										<T keyName="acceptedStep.hideMap">Hide map</T>
									</p>
								</SypacText>
							</button>
						</SypacButton>
					</div>
				</div>
			)}

			{isMapOpen ? (
				<div className="h-[320px] px-5 mb-3">
					<OrderRouteMap
						order={selectedOrder}
						mode={mode}
						showPendingTrucks={showPendingTrucks}
					/>
				</div>
			) : (
				<SypacButton
					variant="secondary"
					size="large"
					className="box-border w-full px-5 py-4"
				>
					<button
						className="w-full h-[42px] bg-alabaster rounded-10 px-5 pt-4 transition"
						type="button"
						onClick={toggleMap}
					>
						<span className="mt-[4px] scale-[1.2]">
							<MapIcon />
						</span>
						<SypacText variant="body-normal-medium">
							<p className="transition group-hover:text-gray-80">
								<T keyName="acceptedStep.showMap">Show map</T>
							</p>
						</SypacText>
					</button>
				</SypacButton>
			)}

			<div className="w-fit flex items-center gap-[6px] py-[2px] pl-1 pr-3 ml-5 mb-4 bg-white border border-solid border-gray-10 rounded-[6px]">
				<WarningIcon />
				<SypacText variant="body-normal-medium">
					<p className="text-[12px] leading-[16px] text-gray-60">
						<T keyName="detailsMap.routeGenerated">
							Route generated based on: Truck Route and Shortest Route criteria.
						</T>
					</p>
				</SypacText>
			</div>
		</div>
	);
};

export default TruckDetailsMap;
